import React, { useId } from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { Textarea, TextareaProps } from '@epoch-ui/components/Textarea';

import {
  FormField,
  FormControl,
  FormDescription,
  FormLabel,
  FormItem,
  FormMessage
} from '../../form';

export interface TextareaFieldProps extends TextareaProps {
  label?: string | React.ReactNode | React.ReactNode[];
  description?: string | React.ReactNode | React.ReactNode[];
  helpText?: string | React.ReactNode | React.ReactNode[];
  inputClassName?: string;
}

export const TextareaField = React.forwardRef<HTMLTextAreaElement, TextareaFieldProps>(
  ({ name, label, description, helpText, className, inputClassName, ...props }, ref) => {
    const formCtx = useFormContext();
    const id = useId();
    return (
      <FormField
        control={formCtx.control}
        name={name || id}
        render={({ field, fieldState }): React.ReactElement => (
          <FormItem className={cn('tw-mt-4', className)}>
            {label && <FormLabel className="tw-mt-0">{label}</FormLabel>}
            {helpText && <FormDescription className="tw-mt-[6px]">{helpText}</FormDescription>}
            <FormControl>
              <Textarea
                {...props}
                {...field}
                value={field.value || ''}
                className={cn('tw-mt-2', inputClassName)}
                error={!!fieldState.error}
                ref={ref}
              />
            </FormControl>
            {description && (
              <FormDescription className="tw-mt-2 tw-text-xs tw-font-normal tw-leading-4 tw-text-muted-foreground">
                {description}
              </FormDescription>
            )}
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);
